import React from 'react'

export default function FaceFeature({ scaleX, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} style={{ opacity: 0.2 }}>
      <path
        d="M0.325955 0L1.07595 5.73999C1.34595 7.63999 1.62595 9.54003 2.00595 11.41C2.36595 13.28 2.81595 15.1399 3.44595 16.9299C3.76595 17.8199 4.12598 18.7 4.60598 19.51C5.06598 20.34 5.66595 21.08 6.44595 21.66C4.64595 20.82 3.50598 18.98 2.72598 17.22C1.92598 15.42 1.42598 13.51 1.03598 11.6C0.295977 7.77998 0.035955 3.88 0.325955 0Z"
        fill={outline}
      />
      <path
        d="M37.6361 0C37.9261 3.87 37.6662 7.76999 36.9462 11.61C36.5562 13.52 36.0561 15.42 35.2561 17.23C34.4761 19 33.3361 20.83 31.5361 21.67C32.3161 21.09 32.9161 20.34 33.3761 19.52C33.8561 18.71 34.2161 17.8299 34.5361 16.9399C35.1661 15.1499 35.6061 13.3 35.9761 11.42C36.3461 9.55004 36.6361 7.65 36.9061 5.75L37.6361 0Z"
        fill={outline}
      />
    </g>
  )
}
